import { render, staticRenderFns } from "./MoreIconButton.vue?vue&type=template&id=68b9ea2a&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MoreIconButton.vue"
export default component.exports